package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_1
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_2
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_3
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_4
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_5
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_6
import gero.composeapp.generated.resources.exp_content_frasi_con_pronomi_7
import gero.composeapp.generated.resources.exp_title_frasi_con_pronomi

fun getFrasiConPronomiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_3,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_4,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_con_pronomi,
            content = Res.string.exp_content_frasi_con_pronomi_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

// Backwards compatibility alias
fun getFrasiPseudoverbaliContent(): List<IExplanation> = getFrasiConPronomiContent()
